import {
  Component
} from '@angular/core';

import * as moment from 'moment';


export class NgxSchedulerCalendarContainerComponent {
  timeSlots = this.getTimeSlots();

  getTimeSlots() {
    const timeInterval = moment().startOf('day');
    const timeSlots = new Array();
    for (let i = 0; i < 24; i++) {
      const timeIntervalText = timeInterval.format('h A');
      timeSlots.push(timeIntervalText);
      timeInterval.add(1, 'hour')
    }
    return timeSlots;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ngx-scheduler-calendar-container',
  template: `
      <div class="calendar-container" fxLayout="column" fxFlex fxLayoutAlign="">
        <ngx-scheduler-calendar-header></ngx-scheduler-calendar-header>
        <ngx-scheduler-calendar-day-view></ngx-scheduler-calendar-day-view>
      </div>
    `,
  styles: [`
.calendar-container {
    min-height:500px; // TODO: rework this

}
  .timeslot {
    min-height: 50px;
    border-bottom: 1px solid black;  
  }
    `]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
